import React, { useState, useEffect } from 'react'

import { useParams } from 'react-router-dom'

import 'web_common/css/LimnTech.css'
import { db } from 'web_common/tsx/api/db/Api'
import { LifemarkUserModel, Company, ImportedPath, AuthToken } from 'web_common/tsx/api/db/Models'

import PreviewPathForm from 'web_common/tsx/components/import/PreviewPathForm'

import ApiError from 'web_common/tsx/components/misc/ApiError'
import PermissionDenied from 'web_common/tsx/components/misc/PermissionDenied'
import Loading from 'web_common/tsx/components/misc/Loading'

import { urls } from 'InternalUrls'

interface PathImportPreviewProps {

}

const PathImportPreview: React.FC<PathImportPreviewProps> = (props) => {
    const { company_id, path_id } = useParams()

    const [apiError, setApiError] = useState<boolean>(false)
    const [lifemarkUser, setLifemarkUser] = useState<LifemarkUserModel|undefined>(undefined)
    const [company, setCompany] = useState<Company|undefined>(undefined)
    const [importedPath, setImportedPath] = useState<ImportedPath|undefined>(undefined)
    const [userToken, setUserToken] = useState<AuthToken|undefined>(undefined)

    useEffect(() => {
        const onCurrentUser = (response: LifemarkUserModel|undefined) =>
        {
            if(response === undefined)
            {
                setApiError(true)
            }
            else
            {
                setLifemarkUser(response)
            }
        }

        db.current_user(onCurrentUser)
    }, [])

    useEffect(() => {
        if(company_id !== undefined)
        {
            const onCompany = (response: Company|undefined) =>
            {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setCompany(response)
                }
            }

            db.company_detail(company_id, onCompany)
        }
    }, [company_id])

    useEffect(() => {
        if(path_id !== undefined)
        {
            const onResponse = (response: ImportedPath|undefined) =>
            {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setImportedPath(response)
                }
            }

            db.imported_path_detail(path_id, onResponse)
        }
    }, [path_id])

    useEffect(() => {
        if(lifemarkUser !== undefined)
        {
            let onResponse = (response: AuthToken|undefined) =>
            {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setUserToken(response)
                }
            }

            db.auth_token(onResponse)
        }
    }, [lifemarkUser])

    if(apiError)
    {
        return (
            <ApiError/>
        )
    }
    else if(lifemarkUser !== undefined && company !== undefined && importedPath !== undefined
        && userToken !== undefined)
    {
        if(lifemarkUser.solo_user === false)
        {
            return (
                <PermissionDenied />
            )
        }
        else
        {
            return (
                <div className='limn-form-container'>
                    <h1 className='limn-header'> Path Import </h1>
                    <PreviewPathForm
                        company={company}
                        path={importedPath}
                        token={userToken}
                        getImportSuccessUrl={urls.getImportSuccess}
                        getImportFailureUrl={urls.getImportFailure}
                    />
                </div>
            )
        }
    }
    else
    {
        return (
            <div className='limn-form-container'>
                <h1 className='limn-header'> Path Import </h1>
                <Loading/>
            </div>
        )
    }
}

export default PathImportPreview
